import React, { Component } from 'react';
import { Jumbotron } from 'react-bootstrap';
import { Typography, Button, CardActions } from '@material-ui/core';
import CallToAction from '@material-ui/icons/CallToAction';
import { PostData } from '../../api/service';

class OnlineMethod extends Component {
    state = {
        isLoaded: false,
        encRequest: '',
        access_code: '',
        action: '',
        errorMessage: ''
    }

    componentDidMount() {
        this.fetchPaymentString();
    }

    fetchPaymentString = () => {
        // Defaults keep the certificate flow working exactly as before; the ID
        // card flow passes its own endpoint and payload.
        const endpoint = this.props.endpoint || '/getpaymentstringcertificate';
        const d = this.props.payload || {
            certificate_request_id: this.props.certificate_request_id,
            email: this.props.email
        };

        PostData(endpoint, d)
            .then((resp) => {
                if (resp && resp.status === true && resp.encRequest && resp.access_code) {
                    this.setState({
                        encRequest: resp.encRequest,
                        access_code: resp.access_code,
                        action: resp.action,
                        isLoaded: true
                    });
                } else {
                    this.setState({
                        errorMessage: (resp && resp.status_text) ? resp.status_text : 'Unable to initiate payment. Please try again later.'
                    });
                }
            })
            .catch(() => {
                this.setState({
                    errorMessage: 'Unable to initiate payment. Please try again later.'
                });
            });
    }

    render() {
        return (
            <div>
                <Jumbotron>
                    <Typography variant="body1">
                        You will now be redirected to the payment page. Please note the following points:
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body2">
                                Follow the payment procedure very carefully
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body2">
                                After a successful payment, an online payment receipt will be generated
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body2">
                                Press the <b>"PAY NOW"</b> button to continue
                            </Typography>
                        </li>
                    </ul>

                    {this.state.errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {this.state.errorMessage}
                        </div>
                    )}

                    {!this.state.isLoaded && !this.state.errorMessage && `Loading . . . Please wait`}

                    {this.state.isLoaded && (
                        <form method="post" action={this.state.action}>
                            <input type="hidden" name="encRequest" value={this.state.encRequest} />
                            <input type="hidden" name="access_code" value={this.state.access_code} />
                            <CardActions>
                                <Button type="submit" variant="contained" color="primary" disabled={!this.state.isLoaded}>
                                    <CallToAction /> &nbsp; Pay Now &#8377; {this.props.amount}
                                </Button>
                            </CardActions>
                        </form>
                    )}
                </Jumbotron>
            </div>
        );
    }
}

export default OnlineMethod;
